import React from 'react';

import { formatFigure, formatMoney } from 'Helpers/formatService';

const figure = (value) => formatFigure(value, formatMoney, { precision: 3 });

import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

const ContractsTable = ({ isLoading, contracts }) => {
    return (
        <div className="inbud-table_wrapper tw-overflow-y-auto tw-max-h-[374px]">
            <table className="inbud-table tw-table-fixed !tw-w-auto">
                <thead className="tw-sticky tw-top-0 tw-z-10">
                    <tr>
                        <th className="tw-w-28">{$t('Contract')}</th>
                        <th className="tw-w-14">{$t('Signed')}</th>
                        <th className="tw-w-40">{$t('Supplier')}</th>
                        <th className="tw-w-32">{$t('Contracted')}</th>
                        <th className="tw-w-24">{$t('Actuals')}</th>
                        <th className="tw-w-24">{$t('Variance')}</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <TableRowSkeleton columns={6} />
                    ) : contracts.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="tw-text-center tw-py-4">
                                {$t('No contracts found')}
                            </td>
                        </tr>
                    ) : (
                        contracts.map((contract, index) => (
                            <tr key={index}>
                                <td>{contract.contract_reference}</td>
                                <td className="tw-text-center">{contract.contract_signed ? $t('Yes') : $t('No')}</td>
                                <td>{contract.supplier.name}</td>
                                <td className="inbud-numeric-cell">{figure(contract.cashflow.total)}</td>
                                <td className="inbud-numeric-cell">{figure(contract.actual_spend)}</td>
                                <td className="inbud-numeric-cell">{figure(contract.variance)}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ContractsTable;
